export default "__VITE_ASSET__Cqrhc4s0__"